import type { RootState } from '@/redux/RootReducer';
import { useSelector } from 'react-redux';
import { useGetShipmentFieldsVisibility } from './use-get-shipment-fields-visibility';

export const useShipmentFieldsVisibility = (columnKeys: string[]): Record<string, boolean | 'PROGRESSING'> => {
  const { selectedCompany } = useSelector((state: RootState) => state.auth);
  const { data = {}, isLoading } = useGetShipmentFieldsVisibility(selectedCompany.companyId);

  // TODO: progressing should not be there as value, needs check
  return columnKeys.reduce(
    (acc, key) => {
      acc[key] = isLoading ? 'PROGRESSING' : Boolean(data?.[key]);
      return acc;
    },
    {} as Record<string, boolean | 'PROGRESSING'>,
  );
};
